import { Component, OnInit } from '@angular/core';
import { ControllerService } from '../shared/services/controller.service';

@Component({
    selector: 'app-references',
    templateUrl: './references.component.html',
    styleUrls: ['./references.component.scss'],
    standalone: false
})
export class ReferencesComponent implements OnInit {

  constructor(private controller: ControllerService) { }


  components = []

  ngOnInit() {

    this.components = this.controller.getSectionComponents()

  }

}
